import React, { useEffect, useState } from 'react'
import SportsKabaddiOutlinedIcon from '@material-ui/icons/SportsKabaddiOutlined';
import { CircularProgress, Button } from '@material-ui/core'
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import firebase from '../firebase'
import 'firebase/firebase-firestore'
import { withRouter } from 'react-router-dom'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import MenuIcon from '@material-ui/icons/Menu';
 import Drawer from '@material-ui/core/Drawer';
 import List from '@material-ui/core/List';
 import ListItem from '@material-ui/core/ListItem';
 import ListItemIcon from '@material-ui/core/ListItemIcon';
 import ListItemText from '@material-ui/core/ListItemText';
 import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
 import Collapse from '@material-ui/core/Collapse';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CachedRoundedIcon from '@material-ui/icons/CachedRounded';
import TextField from '@material-ui/core/TextField';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import DialogTitle from '@material-ui/core/DialogTitle';
import Chip from '@material-ui/core/Chip';
import Backdrop from '@material-ui/core/Backdrop';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import moment from 'moment'
import MailOutlinedIcon from '@material-ui/icons/MailOutlined';
import Avatar from '@material-ui/core/Avatar';
import PolicyOutlinedIcon from '@material-ui/icons/PolicyOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';
import AccountTreeOutlinedIcon from '@material-ui/icons/AccountTreeOutlined';

function Admin(props) {
	const days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
	const [dialogSession, setDialogSession] = useState(false);
	const [listCLass, setListCLass] = useState([]);
	const [menuIsOpen, setMenuIsOpen] = useState(false);
	const [max, setMax] = useState(false);
	const [msjDate, setMsjDate] = useState(undefined);
	const [msjHour, setMsjHour] = useState('');
	const [idAction, setIdAction] = useState('');
	const [currentName, setCurrentName] = useState('');
	const [newName, setNewName] = useState('');
	const [changeName, setChangeName] = useState(false);

	const [dialogDelete, setDialogDelete] = useState(false);
	const [deleteClass, setDeleteClass] = useState(false);
	const [studentName, setStudentName] = useState('');

	const [newClassDate, setNewClassDate] = useState(undefined);
	const [newClassTopic, setNewClassTopic] = useState(undefined);
	const [newClassMax, setNewClassMax] = useState(undefined);
	const [newClassDialog, setNewClassDialog] = useState(false);

	const [dialogDeleteClass, setDialogDeleteClass] = useState(false);
	const [msjStudents, setMsjStudents] = useState(undefined);
	const [msjDicipline, setMsjDicipline] = useState(undefined);

	const [editClassDialog, setEditClassDialog] = useState(false);

	const [backdrop, setBackdrop] = useState(false);

	const currentUser = firebase.getCurrentUsername();
	let actuallyDate = '';
	let rightNow = new Date();
	const baseURL = process.env.PUBLIC_URL;


/* Edit Class -------------------------------------------- */
const editClassDialogOpen = (id, date, length, discipline) => {
	setMsjDate(moment(date).format("YYYY-MM-DDTkk:mm"));
	setIdAction(id);
	setMsjStudents(length);
	setMsjDicipline(discipline);
	setEditClassDialog(true);
	console.log(date)
  };

  const editClassDialogClose = () => {
	setEditClassDialog(false);
  };

async function logout() {
	await firebase.logout()
	props.history.push(baseURL+'/')
}

async function editClassAction() {
	console.log(idAction);
	console.log(new Date(msjDate));
	console.log(msjDicipline);
	console.log(msjStudents);

	firebase.db.collection("class").doc(idAction).set({
		date:new Date(msjDate),
		discipline:msjDicipline,
		max:msjStudents,
	})
	.then(function() {
		console.log("clase editada");
		editClassDialogClose();
		getClasses();
	})
	.catch(function(error) {
		console.error("problema al editar la clase", error);
		editClassDialogClose();
	});

}




/* Use Effect -------------------------------------------- */	

	useEffect (()=> {
		if(!currentUser) {
			return props.history.replace(baseURL+'/login')
		} else{
			if(!currentUser[0].name){
				setCurrentName('');
			}else{
				setCurrentName(currentUser[0].name);
			}
			getClasses();
		}
	},[]);

	

/* Get Classes -------------------------------------------- */	
	const getClasses = () => {
		setBackdrop(true);
		const now = new Date(Date.now());
		let nowAux = new Date(Date.now());
		let start = new Date(now.setHours(now.getHours() - 2));
		const end = new Date(nowAux.setDate(nowAux.getDate() + 7));
		let attendance = undefined;
		const list = firebase.db.collection("class").where("date", ">=", start).where('date', '<', end).orderBy('date');
		list.onSnapshot(function (querySnapshot) {
			const docs = [];
			querySnapshot.forEach( function (doc) {
				const attents = [];
				
				let assistence = undefined;
				attendance = firebase.db.collection("class").doc(doc.id).collection("attendance");
				attendance.onSnapshot(function (querySnapshot2) {
					querySnapshot2.forEach( function (doc2) {
						assistence = currentUser[0].uid == doc2.data().uid ? true : false;
						attents.push({...doc2.data(), id: doc2.id, assisted: assistence });
					})
				});
				docs.push({...doc.data(), id: doc.id, att: attents, disponibles: doc.data().max - attents.length, reserva: attents.find(element => element.assisted == true)});
			});
			setTimeout(()=>{
				setListCLass(docs);
				console.log(docs);
				setBackdrop(false);
			   }, 1000)
		}); 
	}


/* Create month class -------------------------------------------- */	

const createMonthClasses = () => {
	const days = ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sábado'];
	const horario = [];
	var maxDate = new Date('2021', '10', '0').getDate(); // seleccionar el mes para calcular cuanto dias tiene
	for (var i = 1; i <= maxDate; i++) {
	  let diaClase = new Date('10/'+i+'/2021'); // seleccionar el mes a cargar
	  switch(diaClase.getDay()) {
		case 0:
			  break;
			case 1:
				horario.push(
					{
					  date: new Date(diaClase.setHours(10,30)),
					  discipline: 'BJJ NoGi',
					  gym: 'chamartin',
					  max:16
					},
					{
					  date: new Date(diaClase.setHours(14,30)),
					  discipline: 'BJJ',
					  gym: 'chamartin',
					  max:16
					},
					{
						date: new Date(diaClase.setHours('17','00')),
						discipline: 'BJJ Kids',
						gym: 'chamartin',
						max:10
					},
					{
					  date: new Date(diaClase.setHours('18','00')),
					  discipline: 'BJJ basic',
					  gym: 'chamartin',
					  max:16
					},
					{
					  date: new Date(diaClase.setHours('19','00')),
					  discipline: 'BJJ Advanced',
					  gym: 'chamartin',
					  max:16
					},
					{
					  date: new Date(diaClase.setHours(20,30)),
					  discipline: 'BJJ',
					  gym: 'chamartin',
					  max:16
					}
				  );
			  break;
			case 2:
				horario.push(
					{
					  date: new Date(diaClase.setHours(10,30)),
					  discipline: 'BJJ',
					  gym: 'chamartin',
					  max:16
					},
					{
					  date: new Date(diaClase.setHours(17,30)),
					  discipline: 'BJJ Kids',
					  gym: 'chamartin',
					  max:10
					},
					{
					  date: new Date(diaClase.setHours('19','00')),
					  discipline: 'Muay Thai',
					  gym: 'chamartin',
					  max:16
					},
					{
					  date: new Date(diaClase.setHours('20','00')),
					  discipline: 'BJJ NoGi',
					  gym: 'chamartin',
					  max:16
					}
				  );
			  break;
			case 3:
				horario.push(
					{
						date: new Date(diaClase.setHours(10,30)),
						discipline: 'BJJ NoGi',
						gym: 'chamartin',
						max:16
					  },
					  {
						date: new Date(diaClase.setHours(14,30)),
						discipline: 'BJJ',
						gym: 'chamartin',
						max:16
					  },
					 {
						date: new Date(diaClase.setHours('17','00')),
						discipline: 'BJJ Kids',
						gym: 'chamartin',
						max:10
					},
					  {
						date: new Date(diaClase.setHours('18','00')),
						discipline: 'BJJ basic',
						gym: 'chamartin',
						max:16
					  },
					  {
						date: new Date(diaClase.setHours('19','00')),
						discipline: 'BJJ Advanced',
						gym: 'chamartin',
						max:16
					  },
					  {
						date: new Date(diaClase.setHours(20,30)),
						discipline: 'BJJ',
						gym: 'chamartin',
						max:16
					  }
				  );
			  break;
			case 4:
				horario.push(
					{
					  date: new Date(diaClase.setHours(10,30)),
					  discipline: 'BJJ',
					  gym: 'chamartin',
					  max:16
					},
					{
					  date: new Date(diaClase.setHours(17,30)),
					  discipline: 'BJJ Kids',
					  gym: 'chamartin',
					  max:10
					},
					{
					  date: new Date(diaClase.setHours('19','00')),
					  discipline: 'Muay Thai',
					  gym: 'chamartin',
					  max:16
					},
					{
					  date: new Date(diaClase.setHours('20','00')),
					  discipline: 'BJJ NoGi',
					  gym: 'chamartin',
					  max:16
					}
				  );
			  break;
			case 5:
				horario.push(
					{
						date: new Date(diaClase.setHours(10,30)),
						discipline: 'BJJ NoGI',
						gym: 'chamartin',
						max:16
					  },
					{
						date: new Date(diaClase.setHours(14,30)),
						discipline: 'BJJ NoGI',
						gym: 'chamartin',
						max:16
					  },
					  {
						date: new Date(diaClase.setHours('18','00')),
						discipline: 'BJJ Basic',
						gym: 'chamartin',
						max:14
					  },
					  {
						date: new Date(diaClase.setHours('19','00')),
						discipline: 'Open Mat BJJ',
						gym: 'chamartin',
						max:18
					  },
					  {
						date: new Date(diaClase.setHours('20','00')),
						discipline: 'Open Mat BJJ',
						gym: 'chamartin',
						max:18
					  }
				  );
			  break;
			default:
			  console.log('nada', diaClase);
		  }
		}
		console.log(horario);

/*
	horario.forEach((doc) => {
		var docRef = firebase.db.collection("class").doc();
		firebase.batch.set(docRef, doc);
	});
	return firebase.batch.commit();*/
	}
		
/* Dialog session -------------------------------------------- */	
	const dialogOpenSession = () => {
		setDialogSession(true);
	  };
	
	  const dialogCloseSession = () => {
		setDialogSession(false);
	  };
	
	async function logout() {
		await firebase.logout()
		props.history.push(baseURL+'/')
	}

/* Dialog change name -------------------------------------------- */	
const closeChangeName = () => {
	setChangeName(false);
  };

  const openChangeName = () => {
	openMenu();
	setNewName(currentName);
	setChangeName(true);
  };

  const changeNameOperation = () => {

	if(currentName.trim() != newName.trim()){
		var user = firebase.auth.currentUser;
		user.updateProfile({
			displayName: newName.trim()
		}).then(function() {
			setCurrentName(newName.trim());
		}).catch(function(error) {
			console.log('error al actualizar')
		});
	} else{
		console.log('nombre sin cambios')
	}
	setChangeName(false);
  };


/* Dialog delete Class -------------------------------------------- */

const dialogOpenDeleteCLass = (id, hour, discipline, length, date) => {
	setDialogDeleteClass(true)
	setMsjDate(date);
	setMsjHour(hour);
	setMsjStudents(length);
	setMsjDicipline(discipline);
	setIdAction(id);
  };

  const dialogCloseDeleteClass = () => {
	setDialogDeleteClass(false);
  };

  /* Delete Class -------- */

  const deleteClassOperation = () => {
	firebase.db.collection("class").doc(idAction).delete()
	.then(function() {
		console.log("clase eliminada");
		dialogCloseDeleteClass();
		getClasses();
	})
	.catch(function(error) {
		console.error("problema al eliminar la clase", error);
		dialogCloseDeleteClass();
	});
  };

/* Dialog delete -------------------------------------------- */

const dialogOpenDelete = (date, hour, id, idClass, name) => {
	setMsjDate(date);
	setMsjHour(hour);
	setIdAction(id);
	setDeleteClass(idClass);
	setStudentName(name);
	setDialogDelete(true);
  };

  const dialogCloseDelete = () => {
	setDialogDelete(false);
  };


/* Delete reservation -------- */

  const deleteReservation = () => {
	firebase.db.collection("class").doc(idAction).collection('attendance').doc(deleteClass).delete()
	.then(function() {
		console.log("estudiante eliminado");
		dialogCloseDelete();
		getClasses();
	})
	.catch(function(error) {
		console.error("problema al eliminar al estudiante", error);
		dialogCloseDelete();
	});
  };

/* Dialog new class -------------------------------------------- */

  const closeNewClassDialog = () => {
	setNewClassDialog(false);
  };

  const openNewClassDialog = () => {
	openMenu();
	setNewClassDialog(true);
  };

  const addNewClass = () => {
	if(newClassTopic && newClassMax && newClassDate ){
		firebase.db.collection("class").add({
			date: new Date(newClassDate),
			discipline: newClassTopic,
			gym: 'chamartin',
			max: newClassMax
		})
		.then(function() {
			console.log("clase creada");
			setNewClassDate(undefined);
			setNewClassTopic(undefined);
			setNewClassMax(undefined);
			getClasses();
		})
		.catch(function(error) {
			console.error("error al reservar la clase ", error);
		});
	} else{
		console.log('faltan campos')
	}
	setNewClassDialog(false);
  };


/* Menu -------------------------------------------- */	

	const openMenu = () => {
		setMenuIsOpen(!menuIsOpen);
	};


/* refresh -------------------------------------------- */	

	const refresh = () => {
		getClasses();
	};

	

/* reder -------------------------------------------- */
const goToLocation = ()=>{
	props.history.replace(baseURL+'/location')
 }

/* Policy -------------------------------------------- */
	const goToPolicy = ()=>{
	props.history.replace(baseURL+'/policy')
}
/* Students -------------------------------------------- */
	const goToStudents = ()=>{
	props.history.replace(baseURL+'/students')
}

/* Students -------------------------------------------- */
const goToTournament = ()=>{
	props.history.replace(baseURL+'/tournament')
}

const match = (e)=>{
	let list = e.target.parentElement.parentElement.parentElement.getElementsByClassName('studentList').item(0).getElementsByTagName("ol");
	let arr = [];
	for (let item of list) {
		arr.push(item.innerText);
	}
	if (arr.length%2 !== 0){
		arr.push('DESCANSA')
	}
	props.history.replace(baseURL+'/fights', arr);
}

return (
	
	<main>
		<Backdrop className="backdrop"  open={backdrop}>
			<CircularProgress color="inherit" />
		</Backdrop>
		<header className="header-dashboard">
			<MenuIcon onClick={openMenu} />
			<h3>Clases</h3>
			<CachedRoundedIcon onClick={refresh}  />
		</header>
		<section className="container">
			{ listCLass.map(classData => { 
				// conditions 
				let dateToShow= days[classData.date.toDate().getDay()] + " " + classData.date.toDate().getDate() + "/" +((classData.date.toDate().getMonth() + 1) < 10 ? '0' : '') + (classData.date.toDate().getMonth()+1);
				let hourToShow=  classData.date.toDate().getHours() + ":"+ (classData.date.toDate().getMinutes() < 10 ? '0' : '') + classData.date.toDate().getMinutes();
				if(classData.date.toDate().getDate() != actuallyDate){
					actuallyDate = classData.date.toDate().getDate();
					return <React.Fragment>
								<div className="classTitle">{dateToShow}</div> 
								<Accordion key={classData.id}>
									<AccordionSummary  expandIcon={<ExpandMoreIcon />} >
									<div>{hourToShow} - {classData.discipline}  (<span className="maxNum">{classData.att.length}</span> de  {classData.max})</div>
									</AccordionSummary>
									<div className="btnsClasses">
										<Chip
											label="Editar"
											clickable
											onClick={()=>{editClassDialogOpen(classData.id, classData.date.toDate(), classData.max, classData.discipline)}}
											avatar={<EditOutlinedIcon />}
										/>
										<Chip
											label="Eliminar"
											color="secondary"
											clickable
											onClick={()=>{dialogOpenDeleteCLass(classData.id, hourToShow, classData.discipline, classData.att.length, dateToShow)}}
											avatar={<HighlightOffOutlinedIcon />}
										/>
										<Chip
											label="Porrada"
											clickable
											onClick={(e)=>{match(e)}}
											avatar={<SportsKabaddiOutlinedIcon />}
										/>
									</div>
									<AccordionDetails>
										<ul className="studentList">
											{classData.att.map(student => {
												return <ol><Avatar className="avatar" src={student.pic} /><span className={'beltList '+student.belt}></span><span>{student.nick ? student.nick : student.user }</span><span className="btnsList" ><a href={"mailto:" + student.email} className="mail"><MailOutlinedIcon  /></a><HighlightOffOutlinedIcon onClick={() => dialogOpenDelete(dateToShow, hourToShow, classData.id, student.id, student.user)} className='deleteStudent' /></span></ol>
											})}
										</ul>
									</AccordionDetails>
								</Accordion>
							</React.Fragment>	
				} else {
					return<React.Fragment>
								<Accordion key={classData.id}>
									<AccordionSummary  expandIcon={<ExpandMoreIcon />} >
										<div>{hourToShow} - {classData.discipline} (<span className="maxNum">{classData.att.length}</span> de  {classData.max})</div>
									</AccordionSummary>
									<div className="btnsClasses">
										<Chip
											label="Editar"
											clickable
											onClick={()=>{editClassDialogOpen(classData.id, classData.date.toDate(), classData.max, classData.discipline)}}
											avatar={<EditOutlinedIcon />}
										/>
										<Chip
											label="Eliminar"
											color="secondary"
											clickable
											onClick={()=>{dialogOpenDeleteCLass(classData.id, hourToShow, classData.discipline, classData.att.length, dateToShow)}}
											avatar={<HighlightOffOutlinedIcon />}
										/>
										<Chip
											label="Porrada"
											clickable
											onClick={(e)=>{match(e)}}
											avatar={<SportsKabaddiOutlinedIcon />}
										/>
									</div>
									<AccordionDetails>
									<ul className="studentList">
											{classData.att.map(student => {
												return <ol><Avatar className="avatar" src={student.pic} /><span className={'beltList '+student.belt}></span><span>{student.nick ? student.nick : student.user }</span><span className="btnsList" ><a href={"mailto:" + student.email} className="mail"><MailOutlinedIcon  /></a><HighlightOffOutlinedIcon onClick={() => dialogOpenDelete(dateToShow, hourToShow, classData.id, student.id, student.user)} className='deleteStudent' /></span></ol>
											})}
										</ul>
									</AccordionDetails>
								</Accordion>
							</React.Fragment>
				}
			})}
		</section>
		<Dialog
			open={dialogSession}
			onClose={dialogCloseSession}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					¿Deseas cerrar sesión?
				</DialogContentText>
			</DialogContent>
			<DialogActions>
			<Button onClick={dialogCloseSession} color="primary">
				NO
			</Button>
			<Button onClick={logout} color="primary" autoFocus>
				SI
			</Button>
			</DialogActions>
		</Dialog>

		<Dialog open={changeName} onClose={closeChangeName} aria-labelledby="form-dialog-title">
			<DialogContent>
			<DialogContentText id="alert-dialog-description">¿Deseas cambiar tu Nombre?</DialogContentText>
				<TextField
					autoFocus
					margin="dense"
					id="name"
					label="Nombre y Apellido"
					type="text"
					value={newName}
					onChange={e => setNewName(e.target.value)}
					fullWidth
					inputProps={{
						maxLength: 25
					  }}
				/>
			</DialogContent>
			<DialogActions>
			<Button onClick={closeChangeName} color="primary">
				Cancelar
			</Button>
			<Button onClick={changeNameOperation} color="primary">
				Cambiar
			</Button>
			</DialogActions>
		</Dialog>


		<Dialog open={newClassDialog} onClose={closeNewClassDialog} aria-labelledby="form-dialog-title">
			<DialogContent>
			<DialogContentText id="alert-dialog-description">Añadir nueva Clase</DialogContentText>
				<TextField
					autoFocus
					fullWidth
					label="Fecha"
					type="datetime-local"
					defaultValue={rightNow}
					value={newClassDate}
					onChange={e => setNewClassDate(e.target.value)}
					InputLabelProps={{
					shrink: true,
					}}
				/>
				<TextField
					required
					fullWidth
					margin="dense"
					label="Disciplina"
					type="text"
					value={newClassTopic}
					onChange={e => setNewClassTopic(e.target.value)}
					inputProps={{
						maxLength: 25
					  }}
				/>

				<TextField
					required
					fullWidth
					margin="dense"
					label="Aforo"
					type="number"
					value={newClassMax}
					onChange={e => setNewClassMax(e.target.value)}
					inputProps={{
						maxLength: 2
					  }}
				/>			

			</DialogContent>
			<DialogActions>
			<Button onClick={closeNewClassDialog} color="primary">
				Cancelar
			</Button>
			<Button onClick={addNewClass} color="primary">
				Añadir
			</Button>
			</DialogActions>
		</Dialog>

		<Dialog
			open={dialogDelete}
			onClose={dialogCloseDelete}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">{"Vas a eliminar la siguiente reserva"}</DialogTitle>
			<DialogContent>
			<DialogContentText id="alert-dialog-description">
					<strong>{studentName}</strong> : {msjDate} a las {msjHour} Hrs
			</DialogContentText>
			</DialogContent>
			<DialogActions>
			<Button onClick={dialogCloseDelete} color="primary">
				CANCELAR
			</Button>
			<Button onClick={deleteReservation} color="primary" autoFocus>
				ELIMINAR
			</Button>
			</DialogActions>
		</Dialog>


		<Dialog
			open={dialogDeleteClass}
			onClose={dialogCloseDeleteClass}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">{"Vas a eliminar la siguiente Clase"}</DialogTitle>
			<DialogContent>
			<DialogContentText id="alert-dialog-description">
					<strong>{msjDicipline}</strong> : {msjDate} a las {msjHour} Hrs con {msjStudents} reservas
			</DialogContentText>
			</DialogContent>
			<DialogActions>
			<Button onClick={dialogCloseDeleteClass} color="primary">
				CANCELAR
			</Button>
			<Button onClick={deleteClassOperation} color="primary" autoFocus>
				ELIMINAR
			</Button>
			</DialogActions>
		</Dialog>

		<Dialog open={editClassDialog} onClose={editClassDialogClose} aria-labelledby="form-dialog-title">
			<DialogContent>
			<DialogContentText id="alert-dialog-description">Editar Clase</DialogContentText>
				<TextField
					fullWidth
					label="Fecha"
					type="datetime-local"
					value={msjDate}
					onChange={e => setMsjDate(e.target.value)}
					InputLabelProps={{
					shrink: true,
					}}
				/>
				<TextField
					required
					fullWidth
					margin="dense"
					label="Disciplina"
					type="text"
					value={msjDicipline}
					onChange={e => setMsjDicipline(e.target.value)}
					inputProps={{
						maxLength: 25
					  }}
				/>

				<TextField
					required
					fullWidth
					margin="dense"
					label="Aforo"
					type="number"
					value={msjStudents}
					onChange={e => setMsjStudents(e.target.value)}
					inputProps={{
						maxLength: 2
					  }}
				/>			

			</DialogContent>
			<DialogActions>
			<Button onClick={editClassDialogClose} color="primary">
				Cancelar
			</Button>
			<Button onClick={editClassAction} color="primary">
				Editar
			</Button>
			</DialogActions>
		</Dialog>

		<Drawer anchor="left" open={menuIsOpen} onClose={openMenu} >
			<div className="menuHeader">
				<div>
					<h3>{currentName}</h3>
					<h6>{currentUser ? currentUser[0].email : ''}</h6>
				</div>
			</div>
			<List component="nav" aria-label="main mailbox folders">
				<ListItem button onClick={openNewClassDialog}>
					<ListItemIcon>
						<AddCircleOutlineOutlinedIcon />
					</ListItemIcon>
					<ListItemText primary="Añadir clase" />
				</ListItem>
				<ListItem button >
					<ListItemIcon>
						<EventOutlinedIcon />
					</ListItemIcon>
					<ListItemText primary="Crear clases del mes" />
				</ListItem>
				<ListItem button onClick={goToStudents}>
					<ListItemIcon>
						<PeopleAltOutlinedIcon />
					</ListItemIcon>
					<ListItemText primary="Alumnos" />
				</ListItem>
				<ListItem button onClick={goToTournament}>
					<ListItemIcon>
						<AccountTreeOutlinedIcon />
					</ListItemIcon>
					<ListItemText primary="Crear Torneo" />
				</ListItem>
				<ListItem button onClick={goToLocation}>
					<ListItemIcon>
						<LocationOnOutlinedIcon />
					</ListItemIcon>
					<ListItemText primary="Ubicación" />
				</ListItem>
				<ListItem button onClick={goToPolicy}>
					<ListItemIcon>
						<PolicyOutlinedIcon />
					</ListItemIcon>
					<ListItemText primary="Políticas de privacidad" />
				</ListItem>
					
				<ListItem button onClick={dialogOpenSession}>
				<ListItemIcon>
					<ExitToAppIcon />
				</ListItemIcon>
				<ListItemText primary="Cerrar Sesión" />
				</ListItem>
			</List>
			<div class="version">version 0.1.6</div>
		</Drawer>
	</main>
)
}

export default withRouter((Admin))